/**
 * Add some aesthetic changes to the Feedback form.
 */
(function (Drupal, $, once) {
  Drupal.behaviors.modalFeedbackDialogInit = {
    attach(context) {
      function initFeedbackDialog(element) {
        const uiDialog = $('.ui-dialog');
        const uiFeedbackForm = uiDialog.find('.feedback-form');
        if (!uiFeedbackForm.length) {
          // If this is NOT the feedback form, don't mess with it.
          return;
        }

        /** We are on the feedback form, make some alterations.
         ******************************************************
         */
        const uiDialogTitle = uiDialog.find('.ui-dialog-titlebar');
        if (uiDialogTitle.length) {
          // Change the Title bar to look like Figma and not 'default feel'
          uiDialogTitle.addClass('bg-transparent border-0 text-center fs-3');
        }
        const uiButtonPane = uiDialog.find('.ui-dialog-buttonpane');
        if (!uiButtonPane.length) {
          /** Make no assumptions, always test. Simple JS 'ifs' are cheap.
           *  From here down in the script, can't do anything without the
           *  ButtonPane and the ButtonSet, so exit if they don't exist.
           */
          return;
        }
        uiButtonPane.addClass('bg-transparent border-0');

        const uiButtonPaneSet = uiButtonPane.find('.ui-dialog-buttonset');
        // Change the button's parent to flex them apart.
        uiButtonPaneSet.addClass('w-100 d-flex justify-content-between');

        const btnSubmit = uiButtonPane.find('.webform-button--submit');
        if (btnSubmit.length > 0) {
          btnSubmit.addClass('ui-corner-all');
        }

        // Add keyboard accessibility to emoji images.
        $(document).on('keydown', '.edit-emoji-label', function (event) {
          if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            this.click();
          }
        });
      }
      
      // 'off' ensures single event binding with 'on'
      $(window)
        .off('dialog:aftercreate.feedbackDialog')
        .on('dialog:aftercreate.feedbackDialog', function (e, dialog, element) {
          initFeedbackDialog(element);
        });
    },
  };

	Drupal.behaviors.webformModalIOSScrollFix = {
		attach(context) {
			// Run once per page load, multiple hits is invisible but wastes CPU.
			once('webformModalIOSScrollFix', document.documentElement, context).forEach(() => {
				const isIOS = /iP(ad|hone|od)/.test(navigator.platform) ||
					(/Mac/.test(navigator.platform) && 'ontouchend' in document);
				if (!isIOS) return;

				let savedScrollY = 0;
				let returnFocusToThisElement = null;

				// When any Drupal dialog is created, store scroll position.
				jQuery(window).on('dialog:aftercreate.webformModalIOSScrollFix', function (e, dialog, $element) {
					savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
					returnFocusToThisElement = document.activeElement && document.activeElement !== document.body
						? document.activeElement
						: null;
				});

				// On close, put focus back and restore scroll position.
				jQuery(window).on('dialog:afterclose.webformModalIOSScrollFix', function (e, dialog, $element) {
					try {
						if (returnFocusToThisElement && typeof returnFocusToThisElement.focus === 'function') {
							returnFocusToThisElement.focus({ preventScroll: true });
						}
					} catch (err) { /* harmless ignore here */ }
					setTimeout(function () {
						window.scrollTo(0, savedScrollY);
					}, 0);
				});
			});
		}
	};
})(Drupal, jQuery, window.once);

window.closeUIContentDialog = function() {
  jQuery('.ui-dialog-content').dialog('close');
  return false;
}
